<template>
    <div >
        <!--<breadcrumb :routerList="[{to:'/agent/weekMeeting',title:'周清会议列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="经销商编码">
                            <el-input v-model="q.agentCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="经销商名称">
                            <el-input v-model="q.agentName" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="年度">
                            <el-select filterable v-model="q.weekYear" clearable placeholder="请选择"
                                       @change="getqWeeksBySelectYear">
                                <el-option
                                        v-for="(item,index) in yearList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                            <el-select filterable v-model="q.weekTime" clearable  placeholder="请选择"
                            >
                                <el-option
                                        v-for="(item,index) in qweekList"
                                        :key="item.week"
                                        :label="item.weekStr"
                                        :value="item.week">
                                </el-option>
                            </el-select>
                        </el-form-item>


                    </div>
                  <el-collapse-transition>
                    <div v-show="isScreen">
                      <div class="h-thirdColumn w-newColumn">
                        <el-form-item  label="月份" class="h-elformWrap-2" prop="username">
                          <el-select filterable v-model="q.weekMonth" clearable placeholder="请选择"
                          >
                            <el-option
                                v-for="(item,index) in monthList"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="渠道">
                          <brselectlazy category="sales_region"
                                        v-model="q.channelCode"  :v="q.channelCode" :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="召开人">
                          <el-input v-model="q.conveneName" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item  label="创建日期">
                          <el-date-picker type="date" placeholder="选择日期" v-model="q.creationTime"
                                          value-format="yyyy-MM-dd" style="width: 100%;">
                          </el-date-picker>
                        </el-form-item>
                      </div>
                      <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="评分">
                          <brselectlazy category="userCareLevel"
                                        v-model="q.score"  :v="q.score" :clearable="true"/>
                        </el-form-item>
                      </div>
                    </div>
                  </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                  <div class="l-screen" @click="collapseChange">
                    <img :src="isScreen?closeScreen:drawScreen" alt="">
                    <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                  </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button
                                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                @click="createdMeeting" >新增周会议纪要
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border
                        style="width: 100%">

                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="序号"
                            fixed >
                    </el-table-column>
                    <el-table-column
                            prop="agentCode"
                            label="经销商编码"
                            width="110"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="agentName"
                            label="经销商名称"
                            width="125"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="channelName"
                            label="签约渠道"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="weekStr"
                            label="运营会时间(周)"
                            width="125">
                    </el-table-column>
                    <el-table-column
                            prop="conveneCode"
                            label="召开人编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="conveneName"
                            label="召开人名称"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="participants"
                            label="参会人员"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="month"
                            label="月份"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="monthTarget"
                            label="本月目标"
                            width="60">
                    </el-table-column>
                    <el-table-column
                            prop="monthExpect"
                            label="本月预计达成"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="completionRate"
                            label="履约率"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="monthTotal"
                            label="本月累计（万）"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpect"
                            label="下周预计下单（万）"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectYb"
                            label="下周预计下单-样本网"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectYp"
                            label="下周预计下单-药品网"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectYy"
                            label="下周预计下单-云眼网"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectPyx"
                            label="下周预计下单-培养箱"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectLxj"
                            label="下周预计下单-离心机"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekExpectUsj"
                            label="下周预计下单-血液/疫苗网"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="keyTask"
                            label="重点任务描述"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="weekProgressSummary"
                            label="本周进展总结"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nextWeekPlan"
                            label="下周计划"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="weekHighlight"
                            label="本周亮点"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="competitorAnalysis"
                            label="对手分析"
                            width="110">
                    </el-table-column>

<!--                    <el-table-column
                            prop="lianqunName"
                            label="链群"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="problemTypeName"
                            label="问题分类"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="influenceLevel"
                            label="影响及紧急程度"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="problemDeptTypeName"
                            label="资源需求类型"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="endDate"
                            label="要求到位时间"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="jobGroup"
                            label="承接部门"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="jobUsername"
                            label="答复人"
                            width="110">
                    </el-table-column>-->



                    <el-table-column
                            prop="score"
                            label="评分"
                            width="110">
                        <template slot-scope="scope">
                            <brselect  :disabled="!adminFlag" category="userCareLevel" :v="scope.row.score" v-model="scope.row.score"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建日期"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="luname"
                            label="更新人"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
                            width="150">
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="220" >
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="toSee(scope.row)">
                                查看
                            </el-button>
                            <el-button
                                    type="text"
                                    size="small"
                                    @click="toChange(scope.row)"
                                    class="h-tableLink h-btn"
                                    v-if="_user.usercode == scope.row.cucode && !scope.row.score" >
                                修改
                            </el-button>
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="printDetail(scope.row.id)">
                                导出明细
                            </el-button>
                        </template>


                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" @click="saveGrade" v-if="adminFlag">调整评分</el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

    import weekMeetingService from "../../../../api/loud/weekMeeting/weekMeetingService.js";
    import weekYearMonthService from "../../../../api/loud/weekMeeting/weekYearMonthService.js";
    import moment from "moment";
    import updownfile from "../../../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
              // 展开折叠筛选
              isScreen:false,
              closeScreen:require("@/assets/images/pimg/closeallic.png"),
              drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性
                q: {
                    agentCode:null,
                    agentName:null,
                    weekYear:'',
                    weekTime:'',
                    channelCode:'',
                    conveneName:'',
                    creationTime:'',
                    score:'',
                    weekMonth:'',
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    channelCode:null, // 经销商渠道编码
                    channelName:null, // 经销商渠道名称
                    weekTime:null, // 运营会时间
                    conveneCode:null, // 召开人编码
                    conveneName:null, // 召开人名称
                    participants:null, // 参会人员
                    month:null, // 月份
                    monthTarget:null, // 本月目标
                    monthExpect:null, // 本月预计达成
                    completionRate:null, // 履约率
                    monthTotal:null, // 本月累计（万）
                    nextWeekExpect:null, // 下周预计下单（万）
                    nextWeekExpectYb:null, // 下周预计下单-样本网
                    nextWeekExpectYp:null, // 下周预计下单-药品网
                    nextWeekExpectYy:null, // 下周预计下单-云眼网
                    nextWeekExpectPyx:null, // 下周预计下单-培养箱
                    nextWeekExpectLxj:null, // 下周预计下单-离心机
                    nextWeekExpectUsj:null, // 下周预计下单-血液/疫苗网
                    keyTask:null, // 重点任务描述
                    weekProgressSummary:null, // 本周进展总结
                    nextWeekPlan:null, // 下周计划
                    weekHighlight:null, // 本周亮点
                    competitorAnalysis:null, // 对手分析

                    lianqun:null, // 链群
                    lianqunName:null, // 链群
                    problemType:null, // 提出问题分类
                    problemTypeName:null, // 提出问题分类
                    endDate:null, // 回答时间
                    influenceLevel:null, // 影响及紧急程度
                    problemDeptType:null, // 资源需求类型
                    problemDeptTypeName:null, // 资源需求类型
                    dailyQuestion:null, // 协同问题
                    jobGroup:null, // 承接部门
                    jobUsername:null, // 用户名称
                    jobUsercode:null, // 用户名称

                    score:null, // 评分
                    summarize:null, // 总结

                },
                tableSelectedList:[],
                monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
                //table列表
                tableData: [],
                qweekList :[],
                yearList:[new Date().getFullYear()-1,new Date().getFullYear(),new Date() .getFullYear()+1],
                //是否管理员
                adminFlag:false,
            }
        },
        created() {
            if(this.$store.getters.hasRole('swyl_admin')||this.$store.getters.hasRole('swyl_wanglgly')){
                this.adminFlag = true;
            }
            this.query();
        },
        beforeRouteLeave(to, from, next) {
          from.meta.keepAlive = false;
          next();
        },
        beforeRouteEnter(to, from, next) {
          to.meta.keepAlive = true;
          next();
        },
        methods: {
          // 展开折叠
          collapseChange(){
            this.isScreen = !this.isScreen;
          },
            query() {
                weekMeetingService.selecPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    agentName:null,
                    agentCode:null,
                    channelCode:null,
                    conveneName:null,
                    weekMonth:null,
                    creationTime:null,
                    score:null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },
            //新增周会议纪要
            createdMeeting() {
                this.$router.push({path: "/agent/addWeekMeeting"});
            },
            //查看按钮功能
            toSee(q) {
                 this.$router.push({path: '/agent/seeWeekMeeting',query: {id: q.id}});
            },
            //修改销售样表
            toChange(q) {
                this.$router.push({path: "/agent/changeWeekMeeting", query: {id: q.id}});
            },
            //导出明细
            printDetail(x) {
                updownfile.down('/api/swyl/v1/agent/bscAgentWeekMeeting/downloadExcelDetail',{id:x},"get");

            },

            getqWeeksBySelectYear(){
                this.getqWeeks(this.q.weekYear);
            },
            getqWeeks(y){
                weekYearMonthService.getWeekList({year:y}).then(rd => {
                    this.qweekList = rd;
                    this.getKnowWeek();
                })
            },
            getKnowWeek() {
                var week1 = this.getWeekNum();
                this.qweekList.forEach(element => {
                    if(week1 == element.week){
                        this.q.weekTime = element.week
                    }
                });
            },
            //获取今年是第几周
            getWeekNum() {
                //获得当前日期是第几周的方法
                var year = new Date().getFullYear();
                var week = moment(new Date()).format("E");//获得今天是星期几
                console.log("week",week)
                var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
                //今天到1月1号的时间戳之差
                var millisDiff =
                    new Date(moment().format("yyyy-MM-DD")).getTime() -
                    new Date(year + "-01-01").getTime();
                var days =
                    (millisDiff -
                        week * (24 * 60 * 60 * 1000) -
                        (7 - startweek) * (24 * 60 * 60 * 1000)) /
                    86400000;
                return days / 7 + 1;
                //这里加的2代表的是本周和今年1月1号所在的那一周
            },
            //调整评分
            saveGrade(){
                var idlist = [];
                this.tableSelectedList.forEach(element => {
                    idlist.push(element.id);
                });
                if(idlist.length <= 0){
                    this.$msg.msge("请选择要更新的数据!");
                    return false;
                }

                let obj = _.filter(this.tableData,(o)=>{
                    return _.includes(idlist,o.id)

                })
                weekMeetingService.tzGrade(obj).then(rd => {
                    this.$msg.msgs("调整保存成功");
                    this.query();
                })
            },

            //批量导出
            exportExcel(){
                updownfile.down("/api/swyl/v1/agent/bscAgentWeekMeeting/downloadExcel",this.q,"get",'params');
            },
        }
    }
</script>
